/*
 * @Author: huguantao1@jd.com
 * @Date: 2025-02-10 15:16:23
 * @LastEditors: huguantao1@jd.com
 * @LastEditTime: 2025-03-17 21:22:44
 * @FilePath: /intl-pc-jdi-website-ssr/src/components/customerReviews/HelpfulButton.tsx
 * @Description: default
 */
import { useState } from "react";
import { handleHelpfulOperation } from "@/apis/service";
import { observer } from "mobx-react-lite";
import { useStores } from "@/models";
import { callAfterLogin, JDILogin } from "@/lib/jdiClientUtils";
import { sendClickTrack } from "@/tracks/25217";
import { useParams } from "next/navigation";
import { sendClickTrack as reviewListSendClickTrack } from "@/tracks/25338";

interface HelpfulProps {
  commentId?: string;
  helpfulNum?: string;
  currentIsHelp?: boolean;
}

interface HelpProps {
  data: HelpfulProps;
  expConfig?: any;
}
const  HelpfulButton = observer(({ data, expConfig }: HelpProps)=> {
  const { sku: skuId } = useParams<{ sku: string }>(); // 商品id
  const rootStore = useStores();
  const { helpfulNum, commentId, currentIsHelp } = data || {};
  const [helpNum, setHelpNum] = useState<string>(helpfulNum || "0");
  const currentRef: any = useState<HTMLDivElement>()

  const [helpfulState, setHelpfulState] = useState<boolean>(currentIsHelp || false);
  const {helpfulNum: newHelpfulNum = helpNum, helpfulState: newHelpfulState = helpfulState} = rootStore.commentOpstsStore?.helpfuls?.get(commentId) || {}
  const onHandle = async (event: React.MouseEvent) => {
    reviewListSendClickTrack.Productdetail_Comment_Card_Btn({skuid: `${skuId || '-100'}`, commentId: `${commentId || '-100'}`, index: 0, button_name: "1"})
    const parentContainer = currentRef?.current?.closest(".MuiDialog-container");
    if (parentContainer) {
      parentContainer.removeAttribute('tabindex')
    }
   
    callAfterLogin(async ()=> {
      const userInfo = await JDILogin.getInstance().getUserInfo();
      if (userInfo.isLoggedIn) {
        const res = await handleHelpfulOperation({
          commentId: commentId,
          operation: newHelpfulState ? 2 : 1,
        });
        if (res?.data?.result) {
          setHelpfulState(!newHelpfulState);
          const { likeCount } = res?.data || {};
          const num = likeCount !== "0" ? likeCount || "0" : "0"
          setHelpNum(num);
          rootStore.commentOpstsStore.changeHelpState(commentId, {
            helpfulState:!newHelpfulState,
            helpfulNum: num
          })
        }
      }
    })

    sendClickTrack.Productdetail_ReviewsFloor_HelpfulBtn_Click({
      mainskuid: skuId,
      btnStatus: newHelpfulState ? "1" : "0",
    })
    
    event.preventDefault();
  };
  return (
      <div 
        exptag={expConfig?.help?.expTag}
        data-exptag-json-param={JSON.stringify(expConfig?.help?.data)}
        data-exptag-config={expConfig?.help?.config}
        ref={currentRef} className={`btn ${(newHelpfulState) ? "active" : ""}`} onClick={onHandle}>
        <i className="zanIcon mar"></i>
        {`Helpful${newHelpfulNum != "0" ? "(" + newHelpfulNum + ")" : ""}`}
      </div>
  );
})

export default HelpfulButton;
